import { render, staticRenderFns } from "./jumpto-dxl.vue?vue&type=template&id=446778c4"
import script from "./jumpto-dxl.vue?vue&type=script&lang=js"
export * from "./jumpto-dxl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports